import { create } from 'zustand';

export interface User {
  id: number;
  username: string;
  created_at?: string;
}

interface AuthState {
  token: string | null;
  user: User | null;
  isReady: boolean;
  setAuth: (token: string, user: User) => void;
  clearAuth: () => void;
  initAuth: () => void;
}

const TOKEN_KEY = 'wine_token';
const USER_KEY = 'wine_user';

export const useAuthStore = create<AuthState>((set) => ({
  token: null,
  user: null,
  isReady: false,

  setAuth: (token, user) => {
    localStorage.setItem(TOKEN_KEY, token);
    localStorage.setItem(USER_KEY, JSON.stringify(user));
    set({ token, user, isReady: true });
  },

  clearAuth: () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
    set({ token: null, user: null, isReady: true });
  },

  initAuth: () => {
    const token = localStorage.getItem(TOKEN_KEY);
    const userStr = localStorage.getItem(USER_KEY);
    let user: User | null = null;
    if (userStr) {
      try {
        user = JSON.parse(userStr);
      } catch {
        user = null;
      }
    }
    set({ token, user, isReady: true });
  }
}));
